import type {
  CollectionMutationDetailResponse,
  CollectionPaymentProofDetailResponse,
} from '@diamond/shared/types';
import { formatCurrencyIdr } from '@diamond/shared/utils';

import type {
  LHCDetailInvoiceRowData,
  SearchNomorMutasiRowData,
} from '../../../types';

const FALLBACK_VALUE = '-';

const toDisplayValue = (value: string | null | undefined): string =>
  value && value.trim().length > 0 ? value : FALLBACK_VALUE;

export interface MutationDetailDrawerViewModel {
  hasContent: boolean;
  mutationNumber: string;
  poNumber: string;
  poAmount: string;
  overPayment: string;
  // TODO: relatedTransactions needs status field from backend to support "Batal" display
  relatedTransactions: CollectionMutationDetailResponse['transactions'];
  orderPaymentCount: number;
  paymentProofCount: number;
  proofImageUrl: string | null;
  bankAccount: string;
  bankName: string;
}

export const getMutationDetailDrawerViewModel = ({
  mutationDetailData,
  paymentProofDetailData,
  rowData,
  selectedMutation,
}: {
  mutationDetailData?: CollectionMutationDetailResponse | null;
  paymentProofDetailData?: CollectionPaymentProofDetailResponse | null;
  rowData: LHCDetailInvoiceRowData | null;
  selectedMutation: SearchNomorMutasiRowData | null;
}): MutationDetailDrawerViewModel => {
  const detailData = mutationDetailData ?? paymentProofDetailData ?? null;
  const firstOrderPayment = detailData?.order_payments[0] ?? null;
  const paymentProofCount = detailData?.order_payments.reduce(
    (count, payment) => count + payment.payment_proofs.length,
    0
  );

  return {
    hasContent: Boolean(detailData || selectedMutation || rowData),
    mutationNumber:
      selectedMutation?.mutationNo ??
      mutationDetailData?.bank_mutation_number ??
      toDisplayValue(rowData?.bankMutationNo),
    poNumber: detailData?.po_number ?? toDisplayValue(rowData?.poNumber),
    poAmount: detailData
      ? formatCurrencyIdr(detailData.po_amount)
      : toDisplayValue(rowData?.poValue),
    overPayment: toDisplayValue(selectedMutation?.remaining),
    relatedTransactions: detailData?.transactions ?? [],
    orderPaymentCount: detailData?.order_payments.length ?? 0,
    paymentProofCount: paymentProofCount ?? 0,
    proofImageUrl: firstOrderPayment?.payment_proofs[0]?.url ?? null,
    bankAccount: toDisplayValue(firstOrderPayment?.bank_account),
    bankName:
      firstOrderPayment?.bank_name ?? toDisplayValue(selectedMutation?.bank),
  };
};
